import arrowIcon from "assets/icons/svg/AboutUsIcons/arrowup.svg";

// style
import "./style.scss";

const AboutUsIntro = () => {
	return (
		<div className="IntroWrapper">
			<div className="Introtop">
				<div className="top-left">
					{/* <div className="about-text">ABOUT US</div> */}
					<div className="title-content">
						<div className="title-text">
							Make your fondest{" "}
							<span style={{ color: "#fba919" }}> memories</span> at our homes,
							homestays and estates
						</div>
						<div className="title-text-mobile-bottom-border"></div>
					</div>
				</div>
				<div className="top-right">
					<div className="intro_desc">
						Managed, Serviced, and Unlocked
						<br /> by SaffronStays.
					</div>
				</div>
			</div>
			<div className="Introbottom">
				<img
					style={{ width: "100%" }}
					src={
						"https://ik.imagekit.io/5tgxhsqev/saffronstays-media/tr:w-1650,h-762/image/upload/ss3/Image_for_About_Us_Page"
					}
					alt="about us"
				/>
				<img className="arrowupIcon" src={arrowIcon} alt="arrow up" />
			</div>
		</div>
	);
};

export default AboutUsIntro;
